import { Component, Inject } from '@angular/core';
import {
	MAT_DIALOG_DATA,
	MatDialogRef,
	MatDialogClose,
	MatDialogActions,
} from '@angular/material/dialog';
import { IDeleteDialogData } from '@core/services/au-dialog.service';
import { TitleCasePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatRipple } from '@angular/material/core';
import { MatButton } from '@angular/material/button';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	templateUrl: './delete-confirm.component.html',
	imports: [
		MatIcon,
		MatDialogClose,
		MatRipple,
		MatDialogActions,
		MatButton,
		TitleCasePipe,
		NgxTolgeeModule,
	],
})
export class DeleteConfirmComponent {
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: IDeleteDialogData,
		private dialogRef: MatDialogRef<DeleteConfirmComponent>
	) {}

	deleteApproved() {
		this.dialogRef.close(true);
	}
}
